export const reasonsForSeekingLiquidity = [
    { label: "Life Circumstance" },
    { label: "Business Need" },
    { label: "Portfolio Rebalancing" },
    { label: "Tax Motivation" },
    { label: "Regulatory/Compliance" },
    { label: "GP Restructuring" },
    { label: "Other" },
];
